import { Organization, User } from '@/types';
import api from './client/axios';

export const getOrganization = async (user: User): Promise<Organization> => {
  const response = await api.get('/organization');
  return response.data;
};
